<template>
  <!--  edits a json object as a string -->
  <v-text-field
    :rules="rules"
    :label="label"
    :hint="hint"
    :dense="dense"
    :value="formattedModel"
    :persistent-hint="persistentHint"
    @input="val => updateValue(val)"
    :disabled="disabled"
    :hide-details="hideDetails"
  >
    <template v-if="required && label" #label>
      <span class="red--text"><strong>* </strong></span>{{ label }}
    </template>
  </v-text-field>
</template>

<script>
import formRules from '@/mixins/form-rules'
import * as validators from '@/mixins/validators'

export default {
  name: 'MoneyTextField',
  mixins: [formRules],
  props: {
    label: { type: String, required: false },
    hint: { type: String, required: false },
    model: { type: [Object, undefined], required: false },
    required: { type: Boolean, required: false, default: false },
    dense: { type: Boolean, required: false, default: false },
    persistentHint: { type: Boolean, required: false, default: false },
    disabled: { type: Boolean, required: false, default: false },
    hideDetails: { type: Boolean, required: false, default: false },
  },
  data: () => ({}),
  computed: {
    // The display version of the model (with commas)
    formattedModel() {
      const stringJson = JSON.stringify(this.model)
      return stringJson
    },
    computedModel: {
      get() {
        return this.model
      },
      set(val) {
        this.$emit('update:model', val)
      },
    },
    rules() {
      const rules = [validators.mustBeJsonString]
      if (this.required) {
        rules.push(this.isRequired)
      }
      return rules
    },
  },
  methods: {
    // input, text of JSON Object
    // output, json Object
    // Note: If the user types junk (letters), the field shows an error.
    updateValue(newValue) {
      if (newValue == null || newValue === '') {
        this.setValue(null)
        this.$emit('input', null)
        return
      }
      if (validators.isJsonString(newValue)) {
        const obj = JSON.parse(newValue)
        this.setValue(obj)
        this.$emit('input', obj)

      }
    },
    // value is a number at this point
    setValue(value) {
      this.computedModel = value
    },
  },
}
</script>
